import { isAppAuthSelector } from 'pricing-pages-ui/selectors/AuthSelectors';
import { useSelector } from 'react-redux';
import { LoadableWrapper } from '../LoadableWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
// Code splits between an authed component and a public component
// Takes in a loader so we can do the code splitting inside this function.
// See LoadableWrapper above for what the props here mean
const CodeSplitEnvWrapper = ({
  authedComponentLoader,
  authedComponentProps,
  authedComponentLoadingState,
  publicComponentLoader,
  publicComponentProps,
  publicComponentLoadingState
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const hasNoComponentForEnv = isAppAuth && !authedComponentLoader || !isAppAuth && !publicComponentLoader;
  if (hasNoComponentForEnv) return null;
  if (isAppAuth) {
    return /*#__PURE__*/_jsx(LoadableWrapper, {
      loader: authedComponentLoader,
      componentProps: authedComponentProps,
      LoadingComponent: authedComponentLoadingState
    });
  }
  return /*#__PURE__*/_jsx(LoadableWrapper, {
    loader: publicComponentLoader,
    componentProps: publicComponentProps,
    LoadingComponent: publicComponentLoadingState
  });
};
export default CodeSplitEnvWrapper;